import React, { useState, useEffect } from 'react';
import { 
  Box, 
  CssBaseline, 
  useTheme, 
  useMediaQuery,
} from '@mui/material';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [sidebarOpen, setSidebarOpen] = useState(true); // Zawsze otwarty na start

  // Automatycznie zwijaj sidebar na mobile
  useEffect(() => {
    // Usunięto automatyczne zamykanie - sidebar będzie domyślnie otwarty
    // setSidebarOpen(!isMobile);
  }, [isMobile]);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      
      {/* Sidebar */}
      <Sidebar 
        open={sidebarOpen} 
        onToggle={handleSidebarToggle}
        width={240}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          backgroundColor: 'background.default',
          width: { sm: `calc(100% - ${sidebarOpen ? 240 : 64}px)` },
          transition: 'width 0.2s ease-in-out',
        }}
      >
        

        {/* Page Content */}
        <Box
          sx={{
            flexGrow: 1,
            pl: { xs: 3, sm: 6 }, // 3x większy lewy padding
            pr: { xs: 3, sm: 6 }, // 3x większy prawy padding
            pt: { xs: 3, sm: 6 }, // 3x większy górny padding
            pb: { xs: 3, sm: 6 }, // 3x większy dolny padding
            backgroundColor: 'background.default',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout; 